import { Component, OnInit, Inject, Optional, DestroyRef, inject } from '@angular/core';
import { PopUpComponent } from 'src/app/@shared/components/pop-ups/pop-up.component';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import {
  CLOSE,
  DID_YOU_BOARD_BUS,
  YES,
  NO,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-board-bus-confirmation-popup',
    templateUrl: './board-bus-confirmation-popup.component.html',
    styleUrls: ['./board-bus-confirmation-popup.component.scss'],
    standalone: false
})
export class BoardBusConfirmationPopupComponent
  extends PopUpComponent
  implements OnInit
{
  private readonly destroyRef = inject(DestroyRef);

  direction: Direction;
  questionText: string;
  yesText: string;
  noText: string;
  /**
   * a11y: localized aria-label for the new top close (X) button. Popup had no
   * dedicated close affordance before — only Yes / No. Audit requires every
   * popup to expose a close button at the top as the initial focus target.
   */
  closeText: string;

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    private readonly languageService: LanguageService,
    @Optional() @Inject(POPUP_DATA) public data: any
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((language) => {
      this.direction = language.direction;
      this.questionText = DID_YOU_BOARD_BUS[language.language];
      this.yesText = YES[language.language];
      this.noText = NO[language.language];
      this.closeText = CLOSE[language.language];
    });
  }

  handleClick(confirmed: boolean) {
    this.closeCard(confirmed);
  }
}

